import { render, staticRenderFns } from "./ConcernAdviceOverview.vue?vue&type=template&id=c34e65d2"
import script from "./ConcernAdviceOverview.vue?vue&type=script&lang=js"
export * from "./ConcernAdviceOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports